
export const LoginCheck = () => {
    return new Promise((resolve, reject) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage.getItem("ContaKMPCot")}`)
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/CheckLogin`, requestOptions)
            .then(response => response.json())
            .then(result => resolve(result))
            .catch(error => reject(error));
    })
}

export const Log = (data) => {
    return new Promise((resolve, reject) => {
        const myHeaders = new Headers();
        var formdata = new FormData();
        formdata.append("mail", data.mail);
        formdata.append("pass", data.pass);
        formdata.append("check", data.check);
        formdata.append("captcha", data.captcha);
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/Login`, requestOptions)
            .then(response => response.json())
            .then(result => resolve(result))
            .catch(error => reject(error));
    })
}

